import { useState, useEffect } from "react";
import { AiOutlineLink } from "react-icons/ai";
import { TbCheckupList, TbTrash } from "react-icons/tb";
import Pagination from "rc-pagination";
import toast from "react-hot-toast";

import useAxios from "services/useAxios.tsx";

import placeholder from "../../../assets/images/placeholder-image.png";
import "./style.scss";
import "rc-pagination/assets/index.css";
import { pathMaker } from "utils/helperFunctions";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";

export default function ValidationProductFactor() {
  const { execute: getListApi } = useAxios("factor/factoItemListValidate");
  const { execute: updateFactorItem } = useAxios("factor/Update_factors_item");
  const { execute: updateFactorItemApi } = useAxios("factor/updateFactorItem");

  const [list, setList] = useState([]);
  const [listUpdater, setListUpdater] = useState(false);
  const [check, setCheck] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    count: 20,
    total: 0,
  });

  const checkFactorItem = (id) => {
    Swal.fire({
      text: "آیا از تایید این آیتم فاکتور مطمئن هستید؟",
      confirmButtonText: "تایید",
      showCancelButton: true,
      cancelButtonText: "انصراف",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        let time = new Date().getTime();
        let timeStamp = Math.floor(time / 1000);
        let payload = {
          conditions: `id/=/${id}`,
          keyvalues: `check_tm,${timeStamp}`,
        };
        updateFactorItem(payload).then((result) => {
          if (result?.status == 1) {
            setListUpdater((prev) => !prev);
            toast.success("با موفقیت تایید شد.");
          } else {
            toast.error("متاسفانه مشکلی پیش آمده است لطفا مجدد تلاش کنید.");
          }
        });
      }
    });
  };

  const updateFactorItemFunc = (type, id, count) => {
    let payload = { type, factor_item_id: id };
    if (type == "update") {
      payload = { ...payload, count };
    }
    updateFactorItemApi(payload).then((res) => {
      if (res.status == 1) {
        toast.success(res.msg);
        setListUpdater((prev) => !prev);
      } else {
        toast.error(res.msg);
      }
    });
  };

  useEffect(() => {
    getListApi({ page: pagination?.page, count: pagination?.count }).then(
      (result) => {
        if (result?.status == 1) {
          setList(result?.data);
          setPagination((prev) => ({ ...prev, total: result?.total }));
          if (check) {
            toast.success("بررسی مجدد انجام شد.");
            setCheck(false);
          }
        } else {
          toast.error(result?.msg);
        }
      }
    );
  }, [pagination?.page, listUpdater]);

  return (
    <div className="m-4 style">
      <button
        className="bg-success m-2 btn text-light  font-14-500"
        onClick={() => {
          setListUpdater((prev) => !prev);
          setCheck(true);
        }}
      >
        بررسی مجدد
      </button>
      {list?.map((value, index) => (
        <Item
          data={value}
          index={index}
          checkFactorItem={checkFactorItem}
          updateFactorItemFunc={updateFactorItemFunc}
        />
      ))}

      <div className="d-flex justify-content-center mt-4">
        <div>
          <Pagination
            className="px-1"
            total={pagination?.total}
            pageSize={pagination?.count}
            current={pagination?.page}
            onChange={(newPage) => {
              setPagination((prev) => ({ ...prev, page: newPage }));
            }}
          />
        </div>
      </div>
    </div>
  );
}

const Item = ({ data, index, checkFactorItem, updateFactorItemFunc }) => {
  const [count, setCount] = useState(0);
  const validate = () => {
    let inventory = 0;
    let validate = true;
    data?.product?.map((v) => {
      inventory += v?.count;
    });
    if (count < inventory) {
      toast.error(
        "تعداد آیتم فاکتور نباید کمتر از تعداد انبارداری محصولات باشد."
      );
      validate = false;
    }
    return validate;
  };
  return (
    <div
      className={`d-flex flex-wrap my-4 font-14-500 ${
        index % 2 == 0 ? "bg-yel" : "bg-bl"
      }`}
    >
      <div className="contain wp-80">
        <div className="title">شناسه فاکتور</div>
        <div className="value">{data?.factor_id} </div>
      </div>
      <div className="contain wp-100">
        <div className="title">نام فاکتور</div>
        <div className="value"> {data?.store_title}</div>
      </div>
      <div className="contain wp-100">
        <div className="title">شناسه آیتم فاکتور</div>
        <div className="value">{data?.id} </div>
      </div>
      <div className="contain wp-200">
        <div className="title">نام آیتم فاکتور</div>
        <div className="value">{data?.title} </div>
      </div>
      <div className="contain wp-100">
        <div className="title">تعداد آیتم فاکتور</div>
        <div className="value">{data?.count}</div>
      </div>
      <div className="contain wp-150">
        <div className="title">تعداد جدید آیتم فاکتور</div>
        <div className="value d-flex">
          <input
            className="form-control"
            value={count}
            onChange={(e) => {
              if (!isNaN(e?.target?.value)) {
                setCount(e?.target?.value);
              }
            }}
            onBlur={() => {
              if (count == "") {
                setCount(0);
              }
            }}
            onFocus={(e) => {
              if (count == 0) {
                setCount("");
              }
            }}
          />
          <button
            className="btn bg-primary text-light ms-1"
            onClick={() => {
              if (validate()) updateFactorItemFunc("update", data?.id, count);
            }}
          >
            ثبت
          </button>
        </div>
      </div>
      <div className="contain wp-150">
        <div className="title">عملیات</div>
        <div className="value">
          <button
            className="btn"
            data-tooltip-id="validation-delete"
            data-tooltip-content="حذف آیتم فاکتور"
            disabled={data?.product?.length > 0}
            onClick={() => {
              Swal.fire({
                text: "آیا از حذف این آیتم فاکتور مطمئن هستید؟",
                confirmButtonText: "تایید",
                showCancelButton: true,
                cancelButtonText: "انصراف",
              }).then(({ isConfirmed }) => {
                if (isConfirmed) {
                  updateFactorItemFunc("delete", data?.id);
                }
              });
            }}
          >
            <TbTrash
              color={data?.product?.length > 0 ? "darkgray" : "red"}
              style={{
                width: 20,
                height: 20,
              }}
            />
          </button>
          <button
            className="btn"
            data-tooltip-id="validation-valid"
            data-tooltip-content="تایید آیتم فاکتور"
            onClick={() => {
              checkFactorItem(data?.id);
            }}
          >
            <TbCheckupList
              color="green"
              style={{
                width: 20,
                height: 20,
              }}
            />
          </button>
        </div>
      </div>
      <div className="w-100 contain">
        <div className="title">محصولات لینک شده</div>
        <div className="value ">
          {data?.product?.length > 0 ? (
            <ol>
              {data?.product?.map((v) => {
                return (
                  <li className="mr-t-10">
                    <div className="d-flex  flex-wrap align-items-center">
                      <img
                        src={
                          v?.file?.length > 0
                            ? pathMaker(v?.file?.[0]?.url)
                            : placeholder
                        }
                        style={{ width: 60, height: 60, objectFit: "cover" }}
                        className="rounded m-2"
                      />
                      <div
                        className="mr-l-16 text-start"
                        style={{ width: 200 }}
                      >
                        <div className="fw-bold">نام محصول</div>
                        <div>{v?.title}</div>
                      </div>
                      <div className="mr-l-16 mx-4">
                        <div className="fw-bold">موجودی (شرایط فروش)</div>
                        <div>
                          {v?.sum_inventory?.[0]?.sum_inventory ?? "--"}
                        </div>
                      </div>
                      <div className="mr-l-16 mx-4">
                        <div className="fw-bold">انبارداری</div>
                        {v?.count}
                        <div></div>
                      </div>
                      <div className="mr-l-16 mx-4">
                        <div className="fw-bold">سفارشات</div>
                        <div>
                          {v?.order_item_data?.length > 0 ? (
                            <div>
                              {v?.order_item_data?.map((val, ind) => {
                                return (
                                  <span>
                                    سفارش شماره {val?.order_id}({val?.itemcount}
                                    عدد)
                                    {ind < v?.order_item_data?.length - 1
                                      ? ", "
                                      : ""}
                                  </span>
                                );
                              })}
                            </div>
                          ) : (
                            <div>سفارشی برای این محصول ثبت نشده است.</div>
                          )}
                        </div>
                      </div>
                      <div className="mr-l-16">
                        <NavLink
                          to={`/product/${v?.product_id}`}
                          target="_blank"
                          className="text-decoration-none bg-success rounded p-2  "
                        >
                          <AiOutlineLink
                            color="white"
                            style={{ width: 15, height: 15 }}
                          />
                        </NavLink>
                      </div>
                    </div>
                    <hr />
                  </li>
                );
              })}
            </ol>
          ) : (
            <div>محصولی به آیتم فاکتور لینک نشده است.</div>
          )}
        </div>
      </div>
    </div>
  );
};
